export default __webpack_public_path__ + "static/media/perkirkeby1001.456ccdf6.jpg";